
<!--marcador lateral do container--><!--
<div style="position: absolute; left: 0px; z-index: 10000; width: 5px; height: 100%; background-color: rgb(46, 163, 80);"></div>
-->

<div class="backgroundTela">
  &nbsp;
</div>




  <div style="height: 100vh; border-left: 5px solid rgb(207, 121, 1);;border-right: 5px solid rgb(207, 121, 1);" >


  <mat-tab-group [(selectedIndex)]="selectedIndex" animationDuration="100ms" style=" margin-left: 5px;">

    <!--MENU FICHAS -->
    <mat-tab *ngFor="let number of [0];let i=index;" label="📝 Fichas" >

      <div>

        <div style=" width: 100%; overflow:hidden; ">

           <!--Definir o tamanho da tela-->
          <div *ngIf="tipoUsuarioLogado != 3" style="width: 100%; overflow:hidden;  " >

            <div style="text-align: center; background-color: rgb(51, 68, 75); color: #fff;">
              <form [formGroup] = "InitialFormGroup">
                <table  style="width: 100%; text-align: center;" >
                  <tr>


                    <td style="width: 100%; font-size: 14px;">
                      <mat-radio-group  formControlName="consultarOuNovo" aria-label="Selecione um tipo de ficha">
                        <mat-radio-button value="O" checked style="margin-left: 50px; margin-top: 10px;">Consultar por operação</mat-radio-button>
                        <mat-radio-button value="R" checked style="margin-left: 50px; margin-top: 10px;">Consultar por RE</mat-radio-button>
                        <mat-radio-button value="N" style="margin-left: 50px; margin-top: 10px;">Criar nova ficha</mat-radio-button>
                      </mat-radio-group>
                    </td>


                    <td style="width: 100px; text-align: right;">
                      <mat-card style="margin-right: 3px; margin-top: 10px; width: 100px; padding: 0px;   text-align: right;  height: 47px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                        <mat-form-field appearance="outline" style="width: 100px; font-size: 12px; font-weight: 500; text-align: center; text-align: center;">
                          <mat-label style="text-align: center;">

                            <i>ID (Ficha)</i>
                          </mat-label>
                          <input matInput formControlName="idMonitoriaFind" (keyup.enter)="abrirListaConsultaMonitorias()"  style="font-weight: bold; width: 100px; text-align: center; font-size: 16px;">
                        </mat-form-field>
                      </mat-card>
                    </td>

                    <td style="width: 10px; ">
                      <button mat-raised-button type="button" (click)="abrirListaConsultaMonitorias()" style="margin-right: 10px;  margin-top: 10px; background-color: rgb(46, 163, 80); color: #fff;
                         height:48px; font-size: 12px; ">
                        <div style="margin-top: 0px;">
                          <img src="../../assets/img/icones/lupa.png" width="22px">
                        </div>
                      </button>
                    </td>
                  </tr>
                </table>
              </form>
            </div>


            <div style="background-color: rgb(51, 68, 75); margin-bottom: -5px; font-size: 12px; width: 100%; color: white; border-radius: 0px 0px 0px 0px; font-style: italic;">
              <label>
                  &nbsp;
              </label>
              <label *ngIf="labelOperacao != ''">
                / {{labelOperacao}}
              </label>
              <label *ngIf="labelGestor != ''" style=" margin-left: 7px;  ">
                / {{labelGestor}}
              </label>
              <label *ngIf="labelAssistente != ''" style=" margin-left: 7px;  ">
                / {{labelAssistente}}
              </label>
            </div>

            <mat-horizontal-stepper linear #consultar  style="height: 175px; background-color: rgb(51, 68, 75); color: #fff;" *ngIf="InitialFormGroup.value.consultarOuNovo == 'N'">

              <mat-step [stepControl]="firstFormGroup">



                <form [formGroup]="firstFormGroup">
                  <ng-template matStepLabel>Operação</ng-template>

                    <mat-card [hidden]="isBuscaRe" style="margin-left: -17px;  padding: 0px;  width: 50%; height: 47px; margin-top: 20px;">

                      <mat-form-field appearance="outline" style="width: 100%; font-size: 11px;">
                        <mat-label style="text-align: left;">
                          <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                          <b>**Operação</b>
                          <i>(Empresa)</i>
                        </mat-label>
                        <mat-select formControlName="idOperacao" (selectionChange)="preencheCmbGestao($event, selectedIndex, consultar)"
                          style="font-size: 12px; font-weight: 500;">
                          <mat-option *ngFor="let colunas of lstCmbOperacao"
                            [value]="colunas.operIdCdOperacao">{{colunas.operNmOperacao}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-card>

                  <div>
                    <button mat-button matStepperNext>Próximo >>></button>
                  </div>
                </form>
              </mat-step>

              <mat-step [stepControl]="secondFormGroup">
                <form [formGroup]="secondFormGroup">
                  <ng-template matStepLabel>Gestor (Supervisor)</ng-template>

                    <mat-card [hidden]="isBuscaRe" style="margin-left: -17px;  padding: 0px;  width: 50%; height: 47px; margin-top: 20px;">

                      <mat-form-field appearance="outline" style="width: 100%; font-size: 11px;">
                        <mat-label>
                          <img src="../../assets/img/icones/usuario_fem.png" width="20px">&nbsp;&nbsp;
                          <b> **Gestor</b>
                          <i>(Supervisor)</i>
                        </mat-label>
                        <mat-select formControlName="idGestor" (selectionChange)="preencheCmbAssistente($event, selectedIndex, consultar)">
                          <mat-option *ngFor="let colunas of lstCmbGestao"
                            [value]="colunas.usuaIdCdUsuario">{{colunas.usuaNmUsuario}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-card>

                  <div>
                    <button mat-button matStepperPrevious> <<< Voltar</button>
                    <button mat-button matStepperNext>Próximo >>></button>
                  </div>
                </form>
              </mat-step>

              <mat-step [stepControl]="thirdFormGroup">
                <form [formGroup]="thirdFormGroup">
                  <ng-template matStepLabel>Assistente (Operador)</ng-template>

                <mat-card [hidden]="isBuscaRe" style="margin-left: -17px;  padding: 0px;  width: 50%; height: 47px; margin-top: 20px;">
                  <mat-form-field appearance="outline" style="width: 100%; font-size: 11px;">
                    <mat-label>
                      <img src="../../assets/img/icones/usuarios.png" width="20px">&nbsp;&nbsp;
                      <b>**Assistente</b>
                      <i>(Operador)</i>
                    </mat-label>

                    <mat-select formControlName="idAssistente" style="font-size: 12px; font-weight: 500;" (selectionChange)="mostrarBtnCriarFicha($event)">
                      <mat-option *ngFor="let colunas of lstCmbAssistente"
                        [value]="colunas.usuaIdCdUsuario">{{colunas.usuaDsRe}} {{colunas.usuaNmUsuario}}
                      </mat-option>
                    </mat-select>

                  </mat-form-field>
                </mat-card>

                  <div>
                    <button mat-button matStepperPrevious> <<< Voltar</button>
                    <button mat-button id="btnCriarFicha" style="visibility: hidden" (click)="openSnackBar()">Criar ficha</button>
                  </div>
                </form>
              </mat-step>

            </mat-horizontal-stepper>

            <mat-horizontal-stepper linear #criar  style="background-color: rgb(51, 68, 75); color: #fff;" *ngIf="InitialFormGroup.value.consultarOuNovo == 'O'">

              <mat-step [stepControl]="firstFormGroup">
                <form [formGroup]="firstFormGroup">
                  <ng-template matStepLabel>Operação</ng-template>

                    <mat-card [hidden]="isBuscaRe" style="margin-left: -17px;  padding: 0px;  width: 50%; height: 47px; margin-top: 20px;">

                      <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                        <mat-label style="text-align: left;">
                          <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                          <b>**Operação</b>
                          <i>(Empresa)</i>
                        </mat-label>
                        <mat-select formControlName="idOperacao" (selectionChange)="preencheCmbGestao($event, selectedIndex, criar)"
                          style="font-size: 12px; font-weight: 500;">
                          <mat-option *ngFor="let colunas of lstCmbOperacao"
                            [value]="colunas.operIdCdOperacao">{{colunas.operNmOperacao}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-card>


                    <button mat-button matStepperNext>Próximo >>></button>

                </form>
              </mat-step>

              <mat-step [stepControl]="secondFormGroup">
                <form [formGroup]="secondFormGroup">
                  <ng-template matStepLabel>Gestor (Supervisor)</ng-template>

                    <mat-card [hidden]="isBuscaRe" style="margin-left: -17px;  padding: 0px;  width: 50%; height: 47px; margin-top: 20px;">

                      <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                        <mat-label>
                          <img src="../../assets/img/icones/usuario_fem.png" width="20px">&nbsp;&nbsp;
                          <b> **Gestor</b>
                          <i>(Supervisor)</i>
                        </mat-label>
                        <mat-select formControlName="idGestor" (selectionChange)="preencheCmbAssistente($event, selectedIndex, criar)">
                          <mat-option *ngFor="let colunas of lstCmbGestao"
                            [value]="colunas.usuaIdCdUsuario">{{colunas.usuaNmUsuario}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-card>

                  <div>
                    <button mat-button matStepperPrevious> <<< Voltar</button>
                    <button mat-button matStepperNext>Próximo >>></button>
                  </div>
                </form>
              </mat-step>

              <mat-step [stepControl]="thirdFormGroup">
                <form [formGroup]="thirdFormGroup">
                  <ng-template matStepLabel>Assistente (Operador)</ng-template>

                  <table style="width: 100%; margin-top: 20px;">
                    <tr>
                      <td style="width: 10%">
                        <div [hidden]="isBuscaRe" style="margin-left: 0px; width: 100%; text-align: left; vertical-align: bottom;">
                          <mat-slide-toggle formControlName="usuarioAtivo" style="font-size: 12px;" [(ngModel)]="checkedAtivo"
                            (change)="onChangeUsuarioAtivo($event)">
                            <label style="font-size: 12px; color: white; ">
                              {{ativosInativos}}</label>
                          </mat-slide-toggle>
                        </div>
                      </td>

                      <td style="width: 90%">

                        <mat-card [hidden]="isBuscaRe" style="padding: 0px;  width: 50%; height: 47px;">
                          <mat-form-field appearance="outline" style="width: 99%; font-size: 11px;">
                            <mat-label>
                              <img src="../../assets/img/icones/usuarios.png" width="20px">&nbsp;&nbsp;
                              <b>**Assistente</b>
                              <i>(Operador)</i>
                            </mat-label>

                            <mat-select formControlName="idAssistente" (selectionChange)="preencheLabelAssistente($event, criar)" style="font-size: 12px; font-weight: 500;">
                              <mat-option *ngFor="let colunas of lstCmbAssistente"
                                [value]="colunas.usuaIdCdUsuario">{{colunas.usuaDsRe}} {{colunas.usuaNmUsuario}}
                              </mat-option>
                            </mat-select>

                          </mat-form-field>
                        </mat-card>
                      </td>
                    </tr>
                  </table>

                  <div>
                    <button mat-button matStepperPrevious> <<< Voltar</button>
                    <button mat-button matStepperNext>Próximo >>></button>
                  </div>
                </form>
              </mat-step>

              <mat-step [stepControl]="fourthFormGroup">
                <form [formGroup]="fourthFormGroup">
                  <ng-template matStepLabel>Período</ng-template>

                  <table style="width: 50%; margin-top: 20px;">
                    <tr>
                      <td style="width: 50%;">
                        <mat-card style="margin-left: -17px;  padding: 0px;  width: 100%; height: 47px; ">
                          <mat-form-field appearance="outline" style="width: 99%; font-size: 11px;">
                            <mat-label> <img src="../../assets/img/icones/calendario.png" width="20px">&nbsp;&nbsp;
                              <b> **De:</b>
                            </mat-label>
                            <input matInput (dateInput)="setDataAte($event.value)" [matDatepicker]="picker" readonly
                              formControlName="findPeriodoDe">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>

                          </mat-form-field>
                        </mat-card>

                      </td>
                      <td style="width: 50%;">
                        <mat-card style="margin-left: 0px; padding: 0px; width: 100%; height: 47px; ">
                          <mat-form-field appearance="outline" style="width: 99%; font-size: 11px;">
                            <mat-label> <img src="../../assets/img/icones/calendario.png" width="20px">&nbsp;&nbsp;
                              <b>**Até:</b>
                            </mat-label>

                            <input matInput [matDatepicker]="picker1" [min]="minDate" [max]="maxDate" readonly
                              formControlName="findPeriodoAte">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>

                          </mat-form-field>
                        </mat-card>
                      </td>
                    </tr>

                  </table>

                  <div>
                    <button mat-button matStepperPrevious> <<< Voltar</button>
                    <button mat-button matStepperNext>Próximo >>></button>
                <!--<button mat-button color (click)="abrirListaConsultaMonitorias()">Pesquisar ficha</button>-->
                  </div>
                </form>
              </mat-step>

              <mat-step [stepControl]="fifthFormGroup">
                <form [formGroup]="fifthFormGroup">
                  <ng-template matStepLabel>Filtros opcionais</ng-template>

                  <table style="width: 100%; margin-top: 20px;">
                    <tr>
                      <td style="width: 10%;">
                        <div [hidden]="isBuscaRe" style="width: 100%; text-align: left; vertical-align: bottom;">
                          <mat-slide-toggle formControlName="usuarioAtivo" style="font-size: 12px;" [(ngModel)]="checkedAtivo"
                            (change)="onChangeUsuarioAtivo($event)">
                            <label style="font-size: 12px; color: white; margin-bottom: -12px;">
                              {{ativosInativos}}</label>
                          </mat-slide-toggle>
                        </div>
                      </td>

                      <td style="width: 20%;">
                        <mat-card style="margin-left: 10px; padding: 0px; width: 100%; height: 47px; ">
                          <mat-form-field appearance="outline" style="width: 99%; font-size: 11px;">
                            <mat-label>
                              <img src="../../assets/img/icones/status.png" width="20px">&nbsp;&nbsp;
                              <b> Status </b>
                              <i>(Monitoria)</i>
                            </mat-label>
                            <mat-select formControlName="idStatus">
                              <mat-option *ngFor="let status of lstStatus" [value]="status.statIdCdStatus">{{status.statDsStatus}}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </mat-card>
                      </td>

                      <td style="width: 30%; text-align: center;" >

                        <mat-radio-group formControlName="tipoFicha" aria-label="Selecione um tipo de ficha">
                          <mat-radio-button value="M" checked style="margin-left: 15px;">Monitoria</mat-radio-button>
                          <mat-radio-button value="A" style="margin-left: 15px;">Avaliação de Desempenho</mat-radio-button>
                        </mat-radio-group>

                      </td>
                    </tr>
                  </table>

                  <div>
                    <button mat-button matStepperPrevious> <<< Voltar</button>
                    <button mat-button (click)="abrirListaConsultaMonitorias()">Pesquisar monitoria</button>
                  </div>
                </form>
              </mat-step>

            </mat-horizontal-stepper>

            <mat-horizontal-stepper linear #criar  style="height: 175px; background-color: rgb(51, 68, 75); color: #fff;" *ngIf="InitialFormGroup.value.consultarOuNovo == 'R'">

              <mat-step [stepControl]="fifthFormGroup">
                <form [formGroup]="fifthFormGroup">
                  <ng-template matStepLabel>Filtros opcionais</ng-template>

                  <mat-card style="margin-left: -17px;  padding: 0px;  width: 50%; height: 47px; margin-top: 20px;">
                    <mat-form-field appearance="outline" style="font-size: 11px; font-weight: 500;">
                      <mat-label style="color:rgb(255, 0, 85);">
                        <img src="../../assets/img/icones/id.png" width="20px">&nbsp;&nbsp;
                        <b>RE </b>
                        <i>(Assistente)</i>
                      </mat-label>
                      <input matInput type="number" formControlName="re" (keyup)="validaRe()"
                        style="text-align: left; color:rgb(255, 0, 85);">
                    </mat-form-field>
                  </mat-card>

                  <div>
                    <button mat-button matStepperNext>Próximo >>></button>
                  </div>
                </form>
              </mat-step>

              <mat-step [stepControl]="fourthFormGroup">
                <form [formGroup]="fourthFormGroup">
                  <ng-template matStepLabel>Período</ng-template>


                  <table style="width: 50%; margin-top: 20px;">
                      <tr>
                        <td style="width: 50%;">
                          <mat-card style="margin-left: -17px;  padding: 0px;  width: 100%; height: 47px; ">
                          <mat-form-field appearance="outline" style="width: 99%; font-size: 11px;">
                            <mat-label> <img src="../../assets/img/icones/calendario.png" width="20px">&nbsp;&nbsp;
                              <b> **De:</b>
                            </mat-label>
                            <input matInput (dateInput)="setDataAte($event.value)" [matDatepicker]="picker" readonly
                              formControlName="findPeriodoDe">
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>

                          </mat-form-field>
                        </mat-card>

                      </td>
                      <td style="width: 50%;">
                        <mat-card style="margin-left: 0px; padding: 0px; width: 100%; height: 47px; ">
                          <mat-form-field appearance="outline" style="width: 99%; font-size: 11px;">
                            <mat-label> <img src="../../assets/img/icones/calendario.png" width="20px">&nbsp;&nbsp;
                              <b>**Até:</b>
                            </mat-label>

                            <input matInput [matDatepicker]="picker1" [min]="minDate" [max]="maxDate" readonly
                              formControlName="findPeriodoAte">
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>

                          </mat-form-field>
                        </mat-card>
                      </td>
                    </tr>

                  </table>

                  <div>
                    <button mat-button matStepperPrevious> <<< Voltar</button>
                    <button mat-button (click)="abrirListaConsultaMonitorias()">Pesquisar monitoria</button>
                  </div>
                </form>
              </mat-step>

            </mat-horizontal-stepper>

            <!--
            <div style="height: 175px; background-color: rgb(51, 68, 75);">

              <form [formGroup]="formulario" novalidate (ngSubmit)="loadDialogFormularioMonitoria()">

                <table style="width: 100%;">

                  <tr>
                    <td colspan="2">
                      <mat-card [hidden]="isBuscaRe"
                        style="margin-left: 3px; padding: 0px;  width: 98%; height: 47px; margin-top: 5px;">

                        <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                          <mat-label style="text-align: left;">
                            <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                            <b>**Operação</b>
                            <i>(Empresa)</i>
                          </mat-label>
                          <mat-select formControlName="idOperacao" (selectionChange)="preencheCmbGestao($event, selectedIndex)"
                            style="font-size: 12px; font-weight: 500;">
                            <mat-option *ngFor="let colunas of lstCmbOperacao"
                              [value]="colunas.operIdCdOperacao">{{colunas.operNmOperacao}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-card>
                    </td>
                    <td colspan="4">
                      <mat-card [hidden]="isBuscaRe"
                        style="margin-left: 3px; padding: 0px; height: 47px; margin-top: 5px;">
                        <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                          <mat-label>
                            <img src="../../assets/img/icones/usuario_fem.png" width="20px">&nbsp;&nbsp;
                            <b> **Gestor</b>
                            <i>(Supervisor)</i>
                          </mat-label>
                          <mat-select formControlName="idGestor" (selectionChange)="preencheCmbAssistente($event, selectedIndex)">
                            <mat-option *ngFor="let colunas of lstCmbGestao"
                              [value]="colunas.usuaIdCdUsuario">{{colunas.usuaNmUsuario}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-card>
                    </td>

                    <td colspan="2">
                      <mat-card [hidden]="isBuscaRe"
                        style="margin-left: 3px; padding: 0px;  width: 98%; height: 47px; margin-top: 5px;">
                        <mat-form-field appearance="outline" style="width: 99%; font-size: 11px;">
                          <mat-label>
                            <img src="../../assets/img/icones/usuarios.png" width="20px">&nbsp;&nbsp;
                            <b>**Assistente</b>
                            <i>(Operador)</i>
                          </mat-label>

                          <mat-select formControlName="idAssistente" style="font-size: 12px; font-weight: 500;">
                            <mat-option *ngFor="let colunas of lstCmbAssistente"
                              [value]="colunas.usuaIdCdUsuario">{{colunas.usuaDsRe}} {{colunas.usuaNmUsuario}}
                            </mat-option>
                          </mat-select>

                        </mat-form-field>
                      </mat-card>
                    </td>

                    <td colspan="1">
                      <button mat-raised-button type="button" (click)="abrirListaConsultaMonitorias()" style="background-color: rgb(207, 121, 1); color: #fff;
                                                                                  width: 15%;  height:48px; font-size: 12px;  ">
                        <div style="margin-top: 0px;">
                          <img src="../../assets/img/icones/lupa.png" width="30px">
                        </div>
                      </button>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="2">
                      <mat-card style="margin-left: 3px; padding: 0px;  width: 98%; height: 47px; margin-top: 5px;">
                        <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                          <mat-label> <img src="../../assets/img/icones/calendario.png" width="20px">&nbsp;&nbsp;
                            <b> **De:</b>
                            <i>(Periodo)</i>
                          </mat-label>
                          <input matInput (dateInput)="setDataAte($event.value)" [matDatepicker]="picker" readonly
                            formControlName="findPeriodoDe">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                      </mat-card>
                    </td>
                    <td colspan="2">
                      <mat-card style="margin-left: 3px; padding: 0px; height: 47px; margin-top: 5px;">
                        <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                          <mat-label> <img src="../../assets/img/icones/calendario.png" width="20px">&nbsp;&nbsp;
                            <b>**Até:</b>
                            <i>(Periodo)</i>
                          </mat-label>
                          <input matInput [matDatepicker]="picker1" [min]="minDate" [max]="maxDate" readonly
                            formControlName="findPeriodoAte">
                          <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                          <mat-datepicker #picker1></mat-datepicker>
                        </mat-form-field>
                      </mat-card>
                    </td>


                    <td colspan="2">
                      <mat-card style="margin-left: 3px; padding: 0px; height: 47px; margin-top: 5px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                        <mat-form-field appearance="outline" style="width: 98%; font-size: 11px; font-weight: 500;">
                          <mat-label style="color:rgb(255, 0, 85);">
                            <img src="../../assets/img/icones/id.png" width="20px">&nbsp;&nbsp;
                            <b>RE </b>
                            <i>(&nbsp;Assistente&nbsp;)</i>
                          </mat-label>
                          <input matInput type="number" formControlName="re" (keyup)="validaRe()"
                            style="text-align: left; color:rgb(255, 0, 85);">
                        </mat-form-field>
                      </mat-card>
                    </td>

                    <td colspan="2">
                      <mat-card style="margin-left: 3px; padding: 0px; height: 47px; margin-top: 5px;">
                        <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                          <mat-label>
                            <img src="../../assets/img/icones/status.png" width="20px">&nbsp;&nbsp;
                            <b> Status </b>
                            <i>(Monitoria)</i>
                          </mat-label>
                          <mat-select formControlName="idStatus">
                            <mat-option *ngFor="let status of lstStatus" [value]="status.statIdCdStatus">{{status.statDsStatus}}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </mat-card>
                    </td>

                    <td colspan="2">
                      <div style="width: 98%" *ngIf="formulario.controls.idAssistente.value > 0">
                        <button mat-raised-button type="button" (click)="openSnackBar()" style="background-color: rgb(46, 163, 80); color: #fff;
                                                                                  width: 15%;  height: 48px; font-size: 12px;">

                          <div style="margin-top: 0px;">
                            <img src="../../assets/img/icones/novo.png" width="30px">&nbsp;&nbsp;
                          </div>

                        </button>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="2">
                      <mat-card
                        style="margin-left: 3px; padding: 0px;  width: 98%; height: 47px; background-color: rgb(255, 240, 242);  cursor: pointer;">
                        <mat-form-field appearance="outline" style="width: 98%; font-size: 11px; font-weight: 500;">
                          <mat-label style="color:rgb(255, 0, 85);">
                            <img src="../../assets/img/icones/id.png" width="20px">&nbsp;&nbsp;
                            <b>ID </b>
                            <i>(&nbsp;Ficha&nbsp;)</i>
                          </mat-label>
                          <input matInput formControlName="idMonitoriaFind" style="text-align: left; color:rgb(255, 0, 85);">
                        </mat-form-field>
                      </mat-card>
                    </td>
                    <td style="width: 20%; font-size: 12px; color: white; text-align: left; vertical-align: bottom;">
                      <mat-radio-group formControlName="tipoFicha" aria-label="Selecione um tipo de ficha">
                        <mat-radio-button value="M" checked style="margin-left: 8px;">Monitoria</mat-radio-button>
                        <mat-radio-button value="A" style="margin-left: 8px;">Avaliação de Desempenho</mat-radio-button>
                      </mat-radio-group>
                    </td>
                    <td></td>
                    <td></td>
                    <td>
                      <div [hidden]="isBuscaRe" style="width: 100%; text-align: left; vertical-align: bottom;">
                        <mat-slide-toggle formControlName="usuarioAtivo" style="font-size: 12px;" [(ngModel)]="checkedAtivo"
                          (change)="onChangeUsuarioAtivo($event)">
                          <label style="font-size: 12px; color: white; margin-bottom: -12px;">
                            {{ativosInativos}}&nbsp;&nbsp;</label>
                        </mat-slide-toggle>
                      </div>
                    </td>
                  </tr>
                </table>
              </form>
            </div>
            -->

            <div style="margin-top: 0px; height: 5px; width: 100%; background-color:rgb(207, 121, 1);">
                &nbsp;
            </div>

        </div>








              <div *ngIf="tipoUsuarioLogado == 3" style=" width: 100%; overflow:hidden;  ">
                <div style="height: 65px; background-color: rgb(51, 68, 75);">
                    <form [formGroup]="formulario" novalidate (ngSubmit)="loadDialogFormularioMonitoria()">
                      <table  style="width: 99%; margin-left: 10px;">
                        <tr>
                          <td style="width:10%; margin-top: 20px;">
                            <mat-card style="padding: 0px;  width: 100%; height: 47px; margin-top: 5px;">
                               <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                                <mat-label> <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                  <b> **De:</b>
                                  <i>(Periodo)</i>
                                </mat-label>
                                <input matInput  (dateInput)="setDataAte($event.value)" [matDatepicker]="picker" readonly formControlName="findPeriodoDe">
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                              </mat-form-field>
                            </mat-card>
                          </td>
                          <td style="width:1%">
                            &nbsp;
                          </td>
                          <td style="width:10%">
                            <mat-card style="padding: 0px;  width: 100%; height: 47px; margin-top: 5px;">
                              <mat-form-field  appearance="outline" style="width: 98%; font-size: 11px;">
                                <mat-label> <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                                  <b>**Até:</b>
                                  <i>(Periodo)</i>
                                </mat-label>
                                <input matInput [matDatepicker]="picker1" [min]="minDate" [max]="maxDate" readonly formControlName="findPeriodoAte">
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                              </mat-form-field>
                            </mat-card>
                          </td>
                          <td style="width:06%; text-align: center; color: white; font-size: 12px;">
                            - OU -
                          </td>
                          <td style="width:20%; text-align: center; vertical-align: bottom" colspan="3" >
                            <mat-card style="padding: 0px;  width: 100%; height: 47px; background-color: seashell">
                              <mat-form-field appearance="fill" style="width: 98%; font-size: 11px; font-weight: bold; text-align: center;">
                                <mat-label>
                                  <img src="../../assets/img/icones/assistente.png" width="20px">&nbsp;&nbsp;
                                  <b> &nbsp; ID  </b>
                                  <i> &nbsp;(&nbsp;Monitoria&nbsp;)&nbsp;</i>
                                </mat-label>
                                <input matInput formControlName="idMonitoriaFind" style="text-align: center; margin-bottom: -5px;">
                              </mat-form-field>
                            </mat-card>
                          </td>
                          <td style="width:01%">
                            &nbsp;
                          </td>
                          <td style="width:72%">
                            <div style="width: 10%">
                              <button mat-raised-button  type="button" (click)="abrirListaConsultaMonitorias()"
                                              style="background-color: rgb(207, 121, 1); color: #fff;
                                                                              width: 100%; height:48px; font-size: 12px;  ">
                                <div style="margin-top: 0px;">
                                  <img src="../../assets/img/icones/lupa.png" width="30px">&nbsp;&nbsp;
                                </div>
                              </button>
                            </div>
                          </td>

                        </tr>
                      </table>
                    </form>
                  </div>
                  <div style="margin-top: 0px; height: 5px; width: 100%; background-color:rgb(207, 121, 1);">&nbsp;</div>
                </div>



















        </div>



























































        <div style="width: 100%;">


          <table style="width: 100%;   font-size: 12px; background-color: rgb(51, 68, 75); text-align: left;
                        margin:auto; border-radius: 0px 0px 7px 7px;" >
              <tr style="height: 40px;">
                <td style="width: 5%; color: white; text-align: center;">
                   &nbsp;&nbsp;ID
                </td>
                <td style="width: 10%; color: white; text-align: center;">
                    Data
                </td>
                <td style="width: 15%; color: white;">
                    Operação
                </td>
                <td style="width: 20%; color: white;">
                    Avaliador
                </td>
                <td style="width: 10%; color: white;">
                   Perfil
                </td>
                <td style="width: 10%; color: white; text-align: center;">
                    Nota
                </td>
                <td style="width: 15%; color: white;">
                    Formulario
                </td>
                <td style="width: 15%; color: white; text-align: left;">
                    Status atual
                </td>
              </tr>
          </table>

          <mat-card class="mat-elevation-z8" style="padding: 8px;">
              <!--container ajustado dinamicamente-->
              <div [ngClass]="{'subDivContainer': tipoUsuarioLogado != 3, 'subDivContainerOperador': tipoUsuarioLogado == 3  }" style="width: 100%; ">
                  <div [ngClass]="{'subDivAdjustAutoHeight': tipoUsuarioLogado != 3, 'subDivAdjustAutoHeightOperador': tipoUsuarioLogado == 3  }"  style="overflow-y: auto;">

                    <table *ngFor="let colunas of lstMonitorias" style="width: 100%; text-align: left; margin-top: 0px;  font-size: 12px; " >


                      <tr style="cursor: pointer;" (click)="abrirMonitoriaPelaLista(colunas.moniIdCdMonitoria)">

                        <td style="width: 5%;  text-align: center;">
                          &nbsp;&nbsp; {{colunas.moniIdCdMonitoria}}
                        </td>
                        <td style="width: 10%;  text-align: center;">
                          {{colunas.moniDhRegistro | date: 'dd/MM/yyyy'}}
                        </td>
                        <td style="width: 15%; ">
                          {{colunas.operations[0].operNmOperacao}}
                        </td>
                        <td style="width: 20%; ">
                          {{colunas.userMonitor[0].usuaNmUsuario}}
                        </td>
                        <td style="width: 10%; ">
                          {{colunas.profile == null ? '' : colunas.profile[0].perfDsPerfil }}
                        </td>
                        <td style="width: 10%;  text-align: center; vertical-align: bottom;">

                          <div *ngIf="colunas.moniNrTotalPontos > 0"
                            style="width: 50%; height: 30px; margin: 0 auto; font-size: 16px; font-weight: 500; text-align: center;  vertical-align: bottom;
                                                                        border: 2px solid black;
                                                                        background-color: rgb(46, 163, 80); color: #fff;
                                                                        " >
                                {{colunas.moniNrTotalPontos}}

                          </div>

                          <div *ngIf="colunas.moniNrTotalPontos == 0"
                            style="width: 50%; height: 30px; margin: 0 auto; font-size: 16px; font-weight: 500; text-align: center;  vertical-align: bottom;
                                                                         border: 2px solid black;
                                                                        background-color: red; color: #fff;
                                                                        " >
                                {{colunas.moniNrTotalPontos}}

                          </div>


                        </td>
                        <td style="width: 15%; ">
                          {{colunas.forms == null ? '' : colunas.forms[0].formDsFormulario }}
                        </td>
                        <td style="width: 15%;  text-align: left;">
                          {{colunas.statDsStatus}}
                        </td>

                      </tr>
                      <tr>

                        <td colspan="8">
                          <hr/>
                        </td>

                      </tr>
                    </table>

                    <table  *ngIf="lstMonitorias == null || lstMonitorias.length == 0"
                        style="width: 100%; text-align: left; margin-top: 10px;" >
                      <tr style="cursor: pointer;">

                        <td style="width: 100%; height: 450px; text-align: center;">

                           <div style="margin-top: -150px; position: fixed; left: 55%;">Sem registros.</div>

                        </td>

                      </tr>
                    </table>
                  </div>
<!--
                  <div style="width: 100%; margin-top: 05px;">

                      <div style="float: left; width: 69%; ">
                          <button mat-raised-button  type="button" (click)="addParecer()"
                          style="background-color: rgb(46, 163, 80); color: #fff; width: 99%; margin-top: 20px; font-size: 12px">
                          Salvar
                          </button>
                      </div>

                      <div style="float: left; width: 30%; ">
                          <button mat-raised-button type="button" (click)="clearFormularioParecer()" color="warn" style="color: #fff; width: 99%; margin-top: 20px; font-size: 12px ">
                          Cancelar
                          </button>
                      </div>

                  </div>
-->
              </div>
          </mat-card>
          <br/>
      </div>












































    </div>
    </mat-tab>
    <mat-tab *ngFor="let number of [1];let i=index;" label="📝 Relatórios" >

      <div style=" width: 100%; overflow:hidden; ">

        <!--Definir o tamanho da tela-->
        <div *ngIf="tipoUsuarioLogado == 4 || tipoUsuarioLogado == 2 " style=" width: 100%; overflow:hidden;  " >

          <div style="height: 200px; background-color: rgb(51, 68, 75);">

            <br/>
            <mat-horizontal-stepper linear #criar  style="height: 200px; background-color: rgb(51, 68, 75); color: #fff;">

              <mat-step [stepControl]="firstFormGroupR">
                <form [formGroup]="firstFormGroupR">
                  <ng-template matStepLabel>Operação</ng-template>

                    <mat-card style="margin-left: -17px;  padding: 0px;  width: 50%; height: 47px; margin-top: 20px;">
                      <mat-form-field appearance="outline" style="width: 100%; font-size: 11px;">
                        <mat-label style="text-align: left;">
                          <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                          <b>**Operação</b>
                          <i>(Empresa)</i>
                        </mat-label>
                        <mat-select formControlName="operIdCdOperacao" (selectionChange)="preencheCombos($event, selectedIndex)"
                                    style="font-size: 12px; font-weight: 500;">
                          <mat-option *ngFor="let colunas of lstCmbOperacao"
                                      [value]="colunas.operIdCdOperacao">{{colunas.operNmOperacao}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-card>

                  <div>
                    <button mat-button matStepperNext>Próximo >>></button>
                  </div>
                </form>
              </mat-step>

              <mat-step [stepControl]="secondFormGroupR">
                <form [formGroup]="secondFormGroupR">
                  <ng-template matStepLabel>Formulário</ng-template>

                    <table style="width: 100%; margin-top: 20px;">
                      <tr>
                        <td style="width: 40%;">

                          <mat-radio-group formControlName="tipoFicha" aria-label="Selecione um tipo de ficha">
                            <mat-radio-button value="M" checked style="margin-left: 8px;" (change)="preencheFormularios(firstFormGroupR.value.operIdCdOperacao, $event.value)">Monitoria</mat-radio-button>
                            <mat-radio-button value="A" style="margin-left: 35px;" (change)="preencheFormularios(firstFormGroupR.value.operIdCdOperacao, $event.value)">Avaliação de Desempenho</mat-radio-button>
                          </mat-radio-group>

                        </td>
                        <td style="width: 1%;">&nbsp;</td>
                        <td style="width: 59%;">

                          <mat-card style="padding: 0px;  width: 100%; height: 47px; ">
                            <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                              <mat-label>
                                <img src="../../assets/img/icones/status.png" width="20px">&nbsp;&nbsp;
                                <b> **Formulário</b>
                              </mat-label>
                              <mat-select formControlName="formIdCdFormulario">
                                <mat-option *ngFor="let formulario of lstFormularios"
                                            [value]="formulario.formIdCdFormulario">{{formulario.formDsFormulario}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </mat-card>

                        </td>
                      </tr>
                    </table>

                  <div>
                    <button mat-button matStepperPrevious> <<< Voltar</button>
                    <button mat-button matStepperNext>Próximo >>></button>
                  </div>
                </form>
              </mat-step>

              <mat-step [stepControl]="thirdFormGroupR">
                <form [formGroup]="thirdFormGroupR">
                  <ng-template matStepLabel>Período</ng-template>

                  <table style="width:100%; margin-top: 20px;">
                    <tr>
                      <td style="width:25%">
                        <mat-card style="margin-left: -17px; padding: 0px;  width: 100%; height: 47px; ">
                          <mat-form-field appearance="outline" style="width: 99%; font-size: 11px;">
                            <mat-label> <img src="../../assets/img/icones/calendario.png" width="20px">&nbsp;&nbsp;
                              <b> **De:</b>
                            </mat-label>
                            <input matInput  formControlName="moniDhMonitoriaDE" (dateInput)="limitarDataFim($event.value)" [matDatepicker]="picker" readonly>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>

                          </mat-form-field>
                        </mat-card>

                      </td>
                      <td style="width:25%">
                        <mat-card style="margin-left: 0px; padding: 0px; width: 100%; height: 47px; ">
                          <mat-form-field appearance="outline" style="width: 99%; font-size: 11px;">
                            <mat-label> <img src="../../assets/img/icones/calendario.png" width="20px">&nbsp;&nbsp;
                              <b>**Até:</b>
                            </mat-label>

                            <input matInput formControlName="moniDhMonitoriaATE" [matDatepicker]="picker1" [min]="minDataRelatorio" [max]="maxDataRelatorio" readonly >
                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                            <mat-datepicker #picker1></mat-datepicker>

                          </mat-form-field>
                        </mat-card>
                      </td>
                      <td style="width:50%">&nbsp;</td>
                    </tr>

                  </table>

                  <div>
                    <button mat-button matStepperPrevious> <<< Voltar</button>
                    <button mat-button matStepperNext>Próximo >>></button>
                  </div>
                </form>
              </mat-step>

              <mat-step [stepControl]="fourthFormGroupR">
                <form [formGroup]="fourthFormGroupR">
                  <ng-template matStepLabel>Gestor (Supervisor)</ng-template>

                  <mat-card style="margin-left: -17px;  padding: 0px;  width: 50%; height: 47px; margin-top: 20px;">
                    <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                      <mat-label>
                        <img src="../../assets/img/icones/usuario_fem.png" width="20px">&nbsp;&nbsp;
                        <b> Gestor</b>
                        <i>(Supervisor)</i>
                      </mat-label>
                      <mat-select formControlName="usuaIdCdGestor" (selectionChange)="preencheCmbAssistente($event, selectedIndex, criar)" >
                        <mat-option *ngFor="let colunas of lstCmbGestao"
                                    [value]="colunas.usuaIdCdUsuario">{{colunas.usuaNmUsuario}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </mat-card>

                  <div>
                    <button mat-button matStepperPrevious> <<< Voltar</button>
                    <button mat-button matStepperNext>Próximo >>></button>
                  </div>
                </form>
              </mat-step>

              <mat-step [stepControl]="fifthFormGroupR">
                <form [formGroup]="fifthFormGroupR">
                  <ng-template matStepLabel>Assistente</ng-template>

                  <table style="width:100%; margin-top: 20px;">
                    <tr>
                      <td style="width: 20%;">
                        <label style="font-size: 12px;"> Assistentes {{ativosInativos}}&nbsp;&nbsp;</label>
                          <mat-slide-toggle formControlName="usuarioAtivoRelatorio" style="font-size: 12px;"
                          [(ngModel)]="checkedAtivoRelatorio" (change)="onChangeUsuarioAtivoRelatorio($event)" >
                        </mat-slide-toggle>
                      </td>

                      <td style="width: 80%;">
                        <mat-card style="margin-left: -17px;  padding: 0px;  width: 50%; height: 47px;">

                          <mat-form-field appearance="outline" style="width: 99%; font-size: 11px;">
                            <mat-label>
                              <img src="../../assets/img/icones/usuarios.png" width="20px">&nbsp;&nbsp;
                              <b>Assistente</b>
                              <i>(Operador)</i>
                            </mat-label>

                            <mat-select formControlName="usuaIdCdOperador" style="font-size: 12px; font-weight: 500;">
                              <mat-option *ngFor="let colunas of lstCmbAssistente"
                                          [value]="colunas.usuaIdCdUsuario">{{colunas.usuaNmUsuario}}
                              </mat-option>
                            </mat-select>

                          </mat-form-field>
                        </mat-card>

                      </td>
                    </tr>
                  </table>

                  <div>
                    <button mat-button matStepperPrevious> <<< Voltar</button>
                    <button mat-button (click)="buscaMonitorias()">Montar relatório</button>
                  </div>
                </form>
              </mat-step>

            </mat-horizontal-stepper>

            <!--
            <form [formGroup]="formRelatorio" novalidate>
              <table style="width: 99%; margin-left: 5px;">
                <tr>
                  <td class="fieldsFilters" style="width:40%" colspan="1">
                    <mat-card style="padding: 0px;  width: 100%; height: 47px; margin-top: 5px;">
                      <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                        <mat-label style="text-align: left;">
                          <img src="../../assets/img/icones/empresa.png" width="20px">&nbsp;&nbsp;
                          <b>**Operação</b>
                          <i>(Empresa)</i>
                        </mat-label>
                        <mat-select formControlName="operIdCdOperacao" (selectionChange)="preencheCombos($event, selectedIndex)"
                                     style="font-size: 12px; font-weight: 500;">
                          <mat-option *ngFor="let colunas of lstCmbOperacao"
                                      [value]="colunas.operIdCdOperacao">{{colunas.operNmOperacao}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-card>
                  </td>

                  <td class="fieldsFilters" style="width:50%" colspan="1">
                    <mat-card style="padding: 0px;  width: 100%; height: 47px; margin-top: 5px;">
                      <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                        <mat-label>
                          <img src="../../assets/img/icones/status.png" width="20px">&nbsp;&nbsp;
                          <b> **Formulário</b>
                        </mat-label>
                        <mat-select formControlName="formIdCdFormulario">
                          <mat-option *ngFor="let formulario of lstFormularios"
                                      [value]="formulario.formIdCdFormulario">{{formulario.formDsFormulario}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-card>
                  </td>

                  <td class="fieldsFilters" style="width:5%" colspan="1">
                    <mat-card style="padding: 0px;  width: 100%; height: 47px; margin-top: 5px;">
                      <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                        <mat-label> <img src="../../assets/img/icones/calendario.png" width="20px">&nbsp;&nbsp;
                          <b> **De:</b>
                          <i>(Periodo)</i>
                        </mat-label>
                        <input matInput  formControlName="moniDhMonitoriaDE" (dateInput)="limitarDataFim($event.value)" [matDatepicker]="picker" readonly>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </mat-card>
                  </td>
                  <td class="fieldsFilters" style="width:5%" colspan="1">
                    <mat-card style="padding: 0px;  width: 100%; height: 47px; margin-top: 5px;">

                      <mat-form-field  appearance="outline" style="width: 98%; font-size: 11px;">
                        <mat-label> <img src="../../assets/img/icones/calendario.png" width="20px">&nbsp;&nbsp;
                          <b>**Até:</b>
                          <i>(Periodo)</i>
                        </mat-label>
                        <input matInput formControlName="moniDhMonitoriaATE" [matDatepicker]="picker1" [min]="minDataRelatorio" [max]="maxDataRelatorio" readonly >
                        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                        <mat-datepicker #picker1></mat-datepicker>
                      </mat-form-field>

                    </mat-card>
                  </td>


                </tr>

                <tr style="margin-top: 5px;">
                  <td class="fieldsFilters" style="width:35%">
                    <mat-card style="padding: 0px;  width: 100%; height: 47px; margin-top: 5px;">
                      <mat-form-field appearance="outline" style="width: 98%; font-size: 11px;">
                        <mat-label>
                          <img src="../../assets/img/icones/usuario_fem.png" width="20px">&nbsp;&nbsp;
                          <b> Gestor</b>
                          <i>(Supervisor)</i>
                        </mat-label>
                        <mat-select formControlName="usuaIdCdGestor" (selectionChange)="preencheCmbAssistente($event, selectedIndex)" >
                          <mat-option *ngFor="let colunas of lstCmbGestao"
                                      [value]="colunas.usuaIdCdUsuario">{{colunas.usuaNmUsuario}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </mat-card>
                  </td>

                  <td style="width: 20%; font-size: 12px; color: white; text-align: left; vertical-align: bottom;">
                    <mat-radio-group formControlName="tipoFicha" aria-label="Selecione um tipo de ficha">
                      <mat-radio-button value="M" checked style="margin-left: 8px;"  (change)="preencheFormularios(formRelatorio.value.operIdCdOperacao, $event.value)">Monitoria</mat-radio-button>
                      <mat-radio-button value="A" style="margin-left: 8px;"  (change)="preencheFormularios(formRelatorio.value.operIdCdOperacao, $event.value)">Avaliação de Desempenho</mat-radio-button>
                    </mat-radio-group>
                  </td>

                  <td class="fieldsFilters" style="width:15%; text-align: left; color: white; vertical-align: bottom;">
                    <label style="font-size: 12px;"> Assistentes {{ativosInativos}}&nbsp;&nbsp;</label>
                    <mat-slide-toggle formControlName="usuarioAtivoRelatorio" style="font-size: 12px;"
                    [(ngModel)]="checkedAtivoRelatorio" (change)="onChangeUsuarioAtivoRelatorio($event)" >
                                          &nbsp;
                    </mat-slide-toggle>
                  </td>

                  <td class="fieldsFilters" style="width:30%">

                    <mat-card style="padding: 0px;  width: 100%; height: 47px; margin-top: 5px;">


                      <mat-form-field appearance="outline" style="width: 99%; font-size: 11px;">
                        <mat-label>
                          <img src="../../assets/img/icones/usuarios.png" width="20px">&nbsp;&nbsp;
                          <b>Assistente</b>
                          <i>(Operador)</i>
                        </mat-label>

                        <mat-select formControlName="usuaIdCdOperador" style="font-size: 12px; font-weight: 500;">
                          <mat-option *ngFor="let colunas of lstCmbAssistente"
                                      [value]="colunas.usuaIdCdUsuario">{{colunas.usuaNmUsuario}}
                          </mat-option>
                        </mat-select>

                      </mat-form-field>
                    </mat-card>
                  </td>


                  <td class="fieldsFilters">
                    <div>
                      <button mat-raised-button type="button" (click)="buscaMonitorias()"
                                      style="background-color: rgb(207, 121, 1);
                                                                      width: 50%; height:44px;">

                        <div style="margin-top: 0px;">
                          <img src="../../assets/img/icones/impressoraAzul.png"  width="30px">
                        </div>

                      </button>
                    </div>
                  </td>

                </tr>

              </table>
            </form>
            -->

          </div>

          <div style="margin-top: 0px; height: 5px; width: 100%; background-color:rgb(207, 121, 1);">&nbsp;</div>
        </div>

        <div *ngIf="tipoUsuarioLogado != 4 && tipoUsuarioLogado != 2" style=" width: 100%; overflow:hidden;  ">
          <mat-label> Você não tem permissão para impressão de relatório.</mat-label>
        </div>
      </div>
    </mat-tab>

  </mat-tab-group>

</div>
